import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { trackPortfolioNavTabViewed } from '../trackers/portfolio';

// Module-level guard (not a per-mount ref): the Portfolio tab renders from
// several nav surfaces simultaneously (NavBar, MobileNavBar, MenuDropdown), so
// the impression is deduped to once per page-load session rather than firing
// once per component mount.
let hasTrackedThisSession = false;

/**
 * Fires the Portfolio nav-tab impression once per session, the first time a
 * caller reports the tab as actually on screen. Every nav surface mounts
 * regardless of viewport (OuterLayout hides the inactive one with CSS), so each
 * caller must gate on its own visibility rather than on mount.
 */
export const useTrackPortfolioNavTabViewed = isVisible => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== isVisible) {
    t0 = () => {
      if (!isVisible || hasTrackedThisSession) {
        return;
      }
      hasTrackedThisSession = true;
      trackPortfolioNavTabViewed();
    };
    t1 = [isVisible];
    $[0] = isVisible;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};